import { Typography } from 'antd';

import { LeadModel } from '@/typings/models/Lead';
import get from 'lodash/get';

const CustomerStylesProps = ({
  lead,
  styleFieldKey,
}: {
  lead: LeadModel;
  isTable?: boolean;
  styleFieldKey?: string;
}) => {
  const value = get(lead, `customer.styles.${styleFieldKey}`, '-');

  return <Typography.Text ellipsis={{ tooltip: value }}>{value}</Typography.Text>;
};

export default CustomerStylesProps;
